export const BasicPlanWatermark = () => {
  return (
    <div
      style={{
        position: 'absolute',
        bottom: '24px',
        right: '24px',
        display: 'flex',
        alignItems: 'center',
        gap: '12px',
        padding: '10px 18px 10px 20px',
        backgroundColor: '#ffffff',
        borderRadius: '999px',
        boxShadow: '0 10px 30px rgba(0, 0, 0, 0.35), 0 2px 6px rgba(0, 0, 0, 0.2)',
        pointerEvents: 'none',
        isolation: 'isolate',
        zIndex: 2147483000,
      }}
    >
      <span
        style={{
          color: 'rgba(30, 41, 59, 0.7)',
          fontSize: '11px',
          fontWeight: 600,
          letterSpacing: '0.16em',
          textTransform: 'uppercase',
          lineHeight: 1,
          fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif',
        }}
      >
        Powered by
      </span>
      <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
        <img
          src="new_logo.png"
          alt="SignageSpace"
          style={{ height: '28px', width: '28px', objectFit: 'contain', display: 'block' }}
        />
        <span
          style={{
            color: '#475569',
            fontSize: '14px',
            fontWeight: 600,
            letterSpacing: '0',
            lineHeight: 1,
            fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif',
          }}
        >
          SignageSpace
        </span>
      </div>
    </div>
  )
}
